import { ClickAwayListener, Tooltip } from '@material-ui/core';
import * as React from 'react';
import { useState } from 'react';
import './style.scss';

export interface InputLounge {
  value: string;
  action?: any;
  icon?: any;
  placeholder?: any;
  style?: any;
  styles?: any;
  onBlur?: any;
  error?: any;
  onSubmit?: any;
  maxsize?: any;
  disabled?: any;
  required?: boolean;
  showLabel?: boolean;
  requiredLabel?: boolean;
  requiredLabelText?: string;
  label?: string;
  tooltipIcon?: any;
  tooltipText?: string;
}

export const InputLounge = ({
  value = '',
  action,
  icon,
  placeholder,
  label,
  style,
  styles,
  onBlur,
  error,
  onSubmit,
  disabled,
  maxsize,
  required,
  showLabel = true,
  requiredLabel,
  requiredLabelText,
  tooltipIcon,
  tooltipText,
}: InputLounge) => {

  const [open, setOpen] = useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = (event) => {
    event.stopPropagation();
    setOpen(true);
  };
  return (
    <div className={'d-flex flex-column input ' + style} style={{ ...styles }}>
      <div className={'form-group '}>
        {showLabel &&
          <label className="label-input title-text">
            {label}
            {required && <span className={'required-input'}>*</span>}
            {requiredLabel && <span className={'small font-weight-bold'}> {requiredLabelText}</span>}
          </label>
        }
        <div className="d-flex position-relative">
          <input
            onKeyDown={onSubmit}
            onChange={e => action(e)}
            onPaste={e => action(e)}
            value={value}
            type="text"
            className={`form-control ${icon ? "pl-4" : ""} ${error ? "bor-error" : ""}`}
            placeholder={placeholder}
            onBlur={onBlur}
            disabled={Boolean(disabled)}
            maxLength={maxsize}
          />

          {icon && (typeof icon !== "string" ? icon({ className: "input-icon m-0" }) : <img className="input-icon" src={icon} />)}
          {tooltipIcon &&
            <ClickAwayListener onClickAway={handleTooltipClose}>
              <Tooltip
                arrow
                placement="bottom"
                PopperProps={{
                  disablePortal: false,
                }}
                onClose={handleTooltipClose}
                open={open}
                title={tooltipText}
                disableFocusListener
                disableTouchListener
              >
                <img className="tooltip-icon" onClick={(event) => handleTooltipOpen(event)} src={tooltipIcon?.url} />
              </Tooltip>
            </ClickAwayListener>
          }
        </div>
      </div>
      {error && <p style={{ color: 'red', fontSize: 10 }}>{error?.msg}</p>}
    </div>
  );
};


